import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { authAPI } from '../utils/api';

const RegisterPage = () => {
  const { register, isLoading, error } = useAuthStore();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isCompany = pathname === '/sirket-kayit';
  const [form, setForm] = useState({ email: '', password: '', confirmPassword: '', role: isCompany ? 'company' : 'student', companyName: '' });
  const [registered, setRegistered] = useState(false);
  const [kvkk, setKvkk] = useState(false);
  const [localError, setLocalError] = useState('');
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError('');
    if (form.password !== form.confirmPassword) {
      setLocalError('Şifreler eşleşmiyor.');
      return;
    }
    if (!kvkk) {
      setLocalError('Devam etmek için KVKK metnini onaylamanız gerekiyor.');
      return;
    }
    try {
      await register({ email: form.email, password: form.password, role: form.role, companyName: form.companyName });
      setRegistered(true);
    } catch {}
  };

  const handleResend = async () => {
    setResending(true);
    try {
      await authAPI.resendVerification(form.email);
      setResent(true);
    } catch {}
    setResending(false);
  };

  const inp = 'w-full px-3.5 py-2.5 border border-gray-300 rounded-lg text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors';
  const lbl = 'block text-sm font-medium text-gray-700 mb-1.5';

  if (registered) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-white rounded-2xl p-10 shadow-sm text-center">
          <div className="text-5xl mb-4">📧</div>
          <h2 className="text-xl font-bold text-gray-900 mb-3">E-postanızı Doğrulayın</h2>
          <p className="text-gray-500 text-sm leading-relaxed mb-6">
            <strong>{form.email}</strong> adresine doğrulama maili gönderdik.<br />
            Gelen kutunuzu (spam klasörünü de) kontrol edin.
          </p>
          {resent ? (
            <p className="text-green-600 text-sm mb-4">Mail tekrar gönderildi.</p>
          ) : (
            <button
              onClick={handleResend}
              disabled={resending}
              className="text-sm text-blue-600 hover:underline disabled:opacity-50 mb-4 block mx-auto"
            >
              {resending ? 'Gönderiliyor...' : 'Mail gelmedi mi? Tekrar gönder'}
            </button>
          )}
          <button
            onClick={() => navigate('/login')}
            className="px-6 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
          >
            Giriş Sayfasına Git
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl p-10 shadow-sm">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {isCompany ? 'Şirket Hesabı Oluştur' : 'Hesap Oluştur'}
        </h1>
        <p className="text-gray-500 text-sm mb-7">
          {isCompany ? 'Stajyer aramak için kayıt olun' : 'Staj platformuna üye olun'}
        </p>

        {(error || localError) && (
          <div className="bg-red-50 border border-red-200 rounded-lg px-4 py-3 mb-5 text-red-700 text-sm">
            {localError || error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {isCompany && (
            <div>
              <label className={lbl}>Şirket Adı</label>
              <input type="text" required className={inp} value={form.companyName}
                onChange={e => setForm(f => ({ ...f, companyName: e.target.value }))} />
            </div>
          )}
          <div>
            <label className={lbl}>E-posta</label>
            <input type="email" required className={inp} value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
          </div>
          <div>
            <label className={lbl}>Şifre <span className="text-gray-400 font-normal">(min. 8 karakter)</span></label>
            <input type="password" required minLength={8} className={inp} value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
          </div>
          <div>
            <label className={lbl}>Şifre Tekrar</label>
            <input type="password" required minLength={8} className={inp} value={form.confirmPassword}
              onChange={e => setForm(f => ({ ...f, confirmPassword: e.target.value }))} />
          </div>

          {/* KVKK onayı */}
          <div className="flex items-start gap-3 pt-1">
            <input
              type="checkbox"
              id="kvkk"
              checked={kvkk}
              onChange={e => setKvkk(e.target.checked)}
              className="mt-0.5 h-4 w-4 rounded border-gray-300 text-blue-600 cursor-pointer flex-shrink-0"
            />
            <label htmlFor="kvkk" className="text-xs text-gray-600 leading-relaxed cursor-pointer">
              Kişisel verilerimin Türkiye Siber Güvenlik Kümelenmesi tarafından staj süreçleri kapsamında
              işlenmesine, 6698 sayılı KVKK çerçevesinde{' '}
              <a href="/kvkk" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                Aydınlatma Metni
              </a>
              'ni okudum ve kabul ediyorum.
            </label>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 text-white rounded-lg text-sm font-semibold transition-colors mt-2"
          >
            {isLoading ? 'Kayıt olunuyor...' : 'Kayıt Ol'}
          </button>
        </form>

        {isCompany && (
          <p className="text-xs text-gray-400 mt-3 text-center">Şirket hesapları admin onayı gerektirir.</p>
        )}
        <p className="text-center mt-4 text-sm text-gray-500">
          Zaten hesabınız var mı?{' '}
          <Link to={isCompany ? '/sirket-giris' : '/login'} className="text-blue-600 font-medium hover:underline">
            Giriş Yap
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
